import { useMemo } from 'react';
import { Check, Edit } from '@mui/icons-material';
import { Button } from '@mui/material';
import { DataGridProps, GridColDef } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CustomerFragmentFragment, VendorFragmentFragment } from '../../../../api/gql';
import { renderCellOrDefault } from '../../../../components/table/renderCellOrDefault';
import { Table } from '../../../../components/table/Table';

type Props = {
  vendors?: VendorFragmentFragment[];
  onVendorChoose: (customer: VendorFragmentFragment) => void;
} & Partial<DataGridProps>;

export const VendorsTable = ({ vendors, onVendorChoose, ...props }: Props) => {
  const { t } = useTranslation();
  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'name',
        headerName: t('name') as string,
        flex: 1,
        minWidth: 200,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'vatId',
        headerName: t('vatId') as string,
        flex: 1,
        minWidth: 100,
        maxWidth: 150,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'taxId',
        headerName: t('taxId') as string,
        flex: 1,
        minWidth: 100,
        maxWidth: 150,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'address',
        headerName: t('address') as string,
        flex: 1,
        minWidth: 150,
        renderCell: renderCellOrDefault,
      },
      {
        field: 'action',
        flex: 1,
        minWidth: 150,
        maxWidth: 200,
        align: 'right',
        headerName: '',
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <Button startIcon={<Check />} variant={'contained'} onClick={() => onVendorChoose(params.row)}>
            Vybrat
          </Button>
        ),
      },
    ],
    [onVendorChoose, t],
  );

  return <Table id={'vendors'} autoHeight {...props} columns={columns} rows={vendors ?? []} />;
};
